import {v4 as uuidv4} from 'uuid';
import FileUploadComponentGrader = App.Entities.Tasks.ComponentGraders.FileUploadComponentGrader;
import FileUploadBlock = App.Entities.Tasks.Ui.FileUploadBlock;
import {BlockType} from '../block';

export const fileUpload: BlockType<FileUploadBlock, FileUploadComponentGrader> = {
  translationKey: 'file-upload',
  icon: 'upload',
  providesAiContext: true,
  getName: (block) => block.label,
  uiConfigFactory: () => ({
    uuid: uuidv4(),
    type: 'FileUpload',
    name: 'File Upload',
    label: '',
    acceptedFileExtensions: null,
    part: null,
    maxFileSize: null,
    maxNumberOfFiles: null,
  }),
  componentGraderFactory: (uuid) => ({
    uuid: uuidv4(),
    type: 'FileUpload',
    name: 'File Upload Grader',
    uiComponentUuid: uuid,
    noFilesProvidedFeedback: '',
    filesProvidedFeedback: '',
    points: null,
  }),
};
